import { Component, OnInit, Output, EventEmitter, Input, ViewChild, QueryList } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'modal-bill',
    templateUrl: '../../templates/partials/modal-bill.html'
})

export class ModalBillComponent implements OnInit {

    @Input() showModal;
    @Input() html;
    @Output() emitCloseModal = new EventEmitter();
    @ViewChild('billModal') public billModal:ModalDirective;
    constructor() { }

    public onHidden():void {
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public closeModal():void{
        this.emitCloseModal.emit({action:"close", data: null});
    }

    ngOnChanges(changes: any) {
        (this.showModal) ? this.billModal.show() : this.billModal.hide();
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/modal-bill.component.ts